View = require 'view'

t = require('views/internal/teacup-with-helpers')('member_account')
template = t.renderable ({ tempPassword }) ->
  t.p ->
    t.format('temporary-mobile-password')
  t.p '.u-text-align-center', ->
    t.strong ->
      t.text tempPassword

module.exports = class MobilePasswordPopoverView extends View
  viewTitleKey: 'temporary mobile password'
  render: ->
    @$el.html(template({ tempPassword: @options.tempPassword }))
    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/mobile-password-popover-view.coffee